import { render, staticRenderFns } from "./AudioWidgetPanel.vue?vue&type=template&id=749fdbbd&scoped=true"
import script from "./AudioWidgetPanel.vue?vue&type=script&lang=js"
export * from "./AudioWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./AudioWidgetPanel.vue?vue&type=style&index=0&id=749fdbbd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749fdbbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749fdbbd')) {
      api.createRecord('749fdbbd', component.options)
    } else {
      api.reload('749fdbbd', component.options)
    }
    module.hot.accept("./AudioWidgetPanel.vue?vue&type=template&id=749fdbbd&scoped=true", function () {
      api.rerender('749fdbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/AudioWidgetPanel.vue"
export default component.exports